import Mobile from "../components/Mobile";
import Header from "../components/Header";
import SideBar from "../components/SideBar";
import logo from "../assets/brand/logo.png";
import logo1 from "../assets/brand/images.png";
import closs from "../assets/brand/closs.png";
import bg from "../assets/brand/bggg.png";

function Register() {
  return (
    <div class="login">
      <div class="container sm:px-10">
        <div class="block xl:grid grid-cols-2 gap-4">
          <div class="hidden xl:flex flex-col min-h-screen">
            <a href="/home" class="-intro-x flex items-center pt-5">
              <img alt="Midone - HTML Admin Template" class="w-12" src={logo} />
              <span class="text-white text-lg ml-3"> EMLR KICUKIRO </span>
            </a>
            <div class="my-auto">
              <img
                alt="Midone - HTML Admin Template"
                class="-intro-x w-1/2 -mt-16"
                src={closs}
              />
              <div class="-intro-x text-white font-medium text-4xl leading-tight mt-10">
                ACTES 20:28
              </div>
              <div class="-intro-x mt-5 mr-[150px] text-lg text-white text-opacity-70 dark:text-slate-400">
                Take heed therefore unto yourselves, and to all the flock, over
                the which the Holy Ghost hath made you overseers, to feed the
                church of God, which he hath purchased with his own blood.
              </div>
            </div>
          </div>
          <div class="h-screen xl:h-auto flex py-5 xl:py-0 my-10 xl:my-0">
            <div class="my-auto mx-auto xl:ml-20 bg-white dark:bg-darkmode-600 xl:bg-transparent px-5 sm:px-8 py-8 xl:p-0 rounded-md shadow-md xl:shadow-none w-full sm:w-3/4 lg:w-2/4 xl:w-auto">
              <h2 class="intro-x font-bold text-2xl xl:text-3xl text-center xl:text-left">
                Sign Up
              </h2>
              <div class="intro-x mt-8">
                <input
                  type="text"
                  class="intro-x login__input form-control py-3 px-4 block"
                  placeholder="First Name"
                />
                <input
                  type="text"
                  class="intro-x login__input form-control py-3 px-4 block mt-4"
                  placeholder="Last Name"
                />
                <input
                  type="text"
                  class="intro-x login__input form-control py-3 px-4 block mt-4"
                  placeholder="Email"
                />
                <input
                  type="text"
                  class="intro-x login__input form-control py-3 px-4 block mt-4"
                  placeholder="Password"
                />
                <div class="intro-x w-full grid grid-cols-12 gap-4 h-1 mt-3">
                  <div class="col-span-3 h-full rounded bg-success"></div>
                  <div class="col-span-3 h-full rounded bg-success"></div>
                  <div class="col-span-3 h-full rounded bg-success"></div>
                  <div class="col-span-3 h-full rounded bg-slate-100 dark:bg-darkmode-800"></div>
                </div>
                <a
                  href=""
                  class="intro-x text-slate-500 block mt-2 text-xs sm:text-sm"
                >
                  What is a secure password?
                </a>
                <input
                  type="text"
                  class="intro-x login__input form-control py-3 px-4 block mt-4"
                  placeholder="Password Confirmation"
                />
              </div>
              <div class="intro-x flex items-center text-slate-600 dark:text-slate-500 mt-4 text-xs sm:text-sm"></div>
              <div class="intro-x mt-5 xl:mt-8 text-center xl:text-left">
                <a href="/">
                  {" "}
                  <button class="btn  btn-primary py-3 px-4 w-full xl:w-32 mt-3 xl:mt-0 align-top">
                    Register
                  </button>{" "}
                </a>
                <a href="/login">
                  {" "}
                  <button class="btn btn-outline-secondary  py-3 px-4 w-full xl:w-32 xl:mr-3 align-top">
                    Login
                  </button>{" "}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Register;
